// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"9b828c58","166":"278c4981","638":"d485c010","640":"b58bbf01"}[chunkId] + ".chunk.css";
};